import React, {Component} from "react"

import {FormattedMessage} from "@irati/utils/lang"

import IconButton from "../Button/IconButton"
import {Label} from "../Typography"
import padding from "../global/padding"
import Flex from "../Flex"
import RangeInput from "./RangeInput"

import Scale from "./styled/Scale"

interface Props {
  landscapeIcon?: boolean,
  imageScale: number,
  onUpdate: (value: number) => void,
  centerSlider?: boolean
}

const SCALE_ABSOLUTE_MINIMUM = 0.25
const SCALE_MINIMUM_UPPER_LIMIT = 0.3
const SCALE_ABSOLUTE_MAXIMUM = 1.5
const SCALE_MAXIMUM_LOWER_LIMIT = 1.45
const AMOUNT_T0_SCALE = 5

class ScaleInput extends Component<Props> {
  static defaultProps: Pick<Props, "landscapeIcon" | "centerSlider"> = {
    landscapeIcon: false,
    centerSlider: false
  }

  updateLogoScale = (value: number) => {
    const scale = value / 100
    this.props.onUpdate(scale)
  }

  decreaseLogoScale = () => {
    /* if the user tries to decrease the scale value and the current value is greater than the SCALE_ABSOLUTE_MINIMUM
     * but greater by a value less than 0.5 then just set the scale to the SCALE_ABSOLUTE_MINIMUM
     * else decrease the scale value by 0.5 as we've not already reached the SCALE_ABSOLUTE_MINIMUM */
    const {imageScale, onUpdate} = this.props

    if (imageScale > SCALE_ABSOLUTE_MINIMUM) {
      if (imageScale <= SCALE_MINIMUM_UPPER_LIMIT) {
        onUpdate(SCALE_ABSOLUTE_MINIMUM)
      } else {
        onUpdate((imageScale * 100 - AMOUNT_T0_SCALE) / 100)
      }
    }
  }

  increaseLogoScale = () => {
    const {imageScale, onUpdate} = this.props

    if (imageScale < SCALE_ABSOLUTE_MAXIMUM) {
      if (imageScale >= SCALE_MAXIMUM_LOWER_LIMIT) {
        onUpdate(SCALE_ABSOLUTE_MAXIMUM)
      } else {
        onUpdate((imageScale * 100 + AMOUNT_T0_SCALE) / 100)
      }
    }
  }

  render() {
    const {imageScale, landscapeIcon, centerSlider} = this.props

    return (
      <>
        <Label uppercase>
          <FormattedMessage id="account.formItem.slider.labelThree" />
        </Label>
        <Flex
          justifyContent={centerSlider ? "center": "flex-start"}
          alignItems="center"
          width="200px"
          margin={centerSlider ? `0 auto ${padding.base}`: "24px 0"}>
          {landscapeIcon ? (
            <IconButton icon="landscape" size="20" onClick={this.decreaseLogoScale} />
          ) : (
            <Scale direction="right" onClick={this.decreaseLogoScale}>
              -
            </Scale>
          )}
          <RangeInput width={200} value={imageScale * 100} onUpdateValue={this.updateLogoScale} />
          {landscapeIcon ? (
            <IconButton icon="landscape" size="35" onClick={this.increaseLogoScale} />
          ) : (
            <Scale direction="left" onClick={this.increaseLogoScale}>
              +
            </Scale>
          )}
        </Flex>
      </>
    )
  }
}

export default ScaleInput
